import { CommoditySection, Scalars, IsoDocument } from '@bechtel/types';

export interface CommodityDetailProps {
  commoditySections: CommoditySection[];
  showDocuments?: Scalars['Boolean'];
  isoDocument?: IsoDocument | null;
}

export interface CommodityDetailViewProps {
  commodityId: string;
  commodityName: string;
  commodityTag: string;
  workPackageTag: string;
  close: () => void;
  showDocuments?: Scalars['Boolean'];
}
